module.exports = __webpack_public_path__ + "img/invester11.479cdea8.png";